import { Dispatch } from '@reduxjs/toolkit';
import {
  searchProducts,
  getBrands,
  deleteProduct,
  getSimilarProducts,
  getProduct,
  postNewProduct,
  NewUnitConversion} from "../../http/product";
import { IAction, TActionWithoutPayload } from "../actionTypes";
import { removeProduct, updateBrands, updateProducts } from './products.slice';
import { NewProduct, IProductInfo, Product } from "@protoplan/types";
import { TGetState } from '../store';
import { deleteDosingsFromProtocolAsync } from '../protocol/protocol.thunks';
import { enforceProductTypes } from '../../enforceTypes/product';
import { ProtocolTable } from '../protocol/protocol.slice';
import { TBrand } from '../../types/product';
import { TThunkDispatch } from '../hooks';


export const searchProductsAsync = (query?: string, suppId?: number) => async(
  dispatch: Dispatch<IAction<Product[] | undefined>>) =>
{
  return searchProducts(query, suppId)
    .then(data => dispatch(updateProducts(enforceProductTypes(data || []))).payload);
};

export const getProductAsync = (productId: number) => async(dispatch: Dispatch<IAction<Product[] | undefined>>) =>
{
  return getProduct(productId)
    .then(product =>
    {
      if(!product)
        return;

      const [p] = enforceProductTypes([product]);
      dispatch(updateProducts([p]));
      return p;
    });
};

export const retrieveSimilarProductsAsync = (
  productId: number) => async(dispatch: Dispatch<IAction<Product[] | undefined>>) =>
{
  return getSimilarProducts(productId)
    .then(data => dispatch(updateProducts(data ? enforceProductTypes(data) : [])));
};

export const retrieveBrandsAsync = () => async(dispatch: Dispatch<IAction<TBrand[]>>) =>
{
  return getBrands()
    .then(data => dispatch(updateBrands(data)));
};

export const submitNewProductAsync = (product: NewProduct, unitConversions?: NewUnitConversion[]) => async(
  dispatch: TThunkDispatch,
  getState: TGetState) =>
{
  return postNewProduct(product, unitConversions)
    .then(product =>
    {
      if(!product)
        return;

      const products = getState().products.products as IProductInfo[] | undefined;
      const newProducts = enforceProductTypes([product]);
      dispatch(updateProducts(products ? products.concat(newProducts) : newProducts));

      return product;
    });
};

export const deleteProductAsync = (productId: number) => async(
  dispatch: Dispatch<TActionWithoutPayload | IAction<string>>,
  getState: TGetState) =>
{
  const protocols = getState().protocol.protocols as ProtocolTable[];

  // Also remove any listings from protocol
  protocols.forEach(p =>
  {
    if(!p.dosings)
      return;

    const dosingIdsToRemoveFromProtocol = p.dosings
      .filter(row => row.productId === productId)
      .map(row => row.dosingId);

    deleteDosingsFromProtocolAsync(p.protocolId, dosingIdsToRemoveFromProtocol)(dispatch, getState);
  });

  dispatch(removeProduct(productId));
  return deleteProduct(productId);
};
